import ReactModal from 'react-modal';

import { ReactComponent as IcZoomIn } from 'assets/img/icon/zoomIn.svg';
import { ReactComponent as IcZoomOut } from 'assets/img/icon/zoomOut.svg';
import { makeGetToken } from 'lib/selector';
import React from 'react';
import { FaTimes } from 'react-icons/fa';
import { connect } from 'react-redux';
import { replaceAll } from 'utils';
ReactModal.setAppElement('#root');

const customStyles = {
  content: {
    top: '120px',
    left: '150px',
    right: '150px',
    bottom: '120px',
    background: '#ffffff',
    border: '0',
  },
  overlay: {
    backgroundColor: 'transparent',
  },
};

const customStylesZoom = {
  content: {
    top: '25px',
    left: '0',
    right: '0',
    bottom: '0',
    background: '#ffffff',
    border: '0',
  },
  overlay: {
    backgroundColor: 'transparent',
  },
};

function TradingViewModal(props) {
  const frameRef = React.useRef(null);
  const [zoom, setZoom] = React.useState(false);
  const { onClose, token, theme, lang, symbol } = props;

  function mapIndex(params) {
    switch (params) {
      case 'HNXINDEX':
        return 'HNX';
        break;
      case 'UPCOMINDEX':
        return 'UPCOM';
        break;
      case 'VN30INDEX':
        return 'VN30';
        break;

      default:
        return params;
        break;
    }
  }

  return (
    <ReactModal
      isOpen={true}
      contentLabel="onRequestClose Example"
      onRequestClose={onClose}
      shouldCloseOnOverlayClick={true}
      style={zoom ? customStylesZoom : customStyles}
    >
      <div className="p-2 h-100">
        <div className="py-1 d-flex justify-content-between">
          <div className="txt-dark fz-12 " style={{ fontWeight: '600' }}>
            Chỉ số thị trường: {symbol}
          </div>
          <div>
            {!zoom && (
              <IcZoomOut
                className="mr-2 text-dark"
                onClick={() => setZoom(true)}
              />
            )}
            {zoom && (
              <IcZoomIn
                className="mr-2 text-dark"
                onClick={() => setZoom(false)}
              />
            )}
            <FaTimes onClick={onClose} color="var(--dark)" />
          </div>
        </div>
        <iframe
          ref={frameRef}
          title="chart"
          src={
            '/chartTVS/?resolution=D&symbol=' +
            (symbol
              ? mapIndex(replaceAll(symbol, '-', '').toUpperCase())
              : 'VNINDEX') +
            '&lang=' +
            lang +
            '&theme=light' +
            // theme +
            (token ? `&u=${token?.user}` : '')
          }
          scrolling="no"
          style={{ height: 'calc(100% - 32px)' }}
        ></iframe>
      </div>
    </ReactModal>
  );
}

const makeMapStateToProps = () => {
  const getToken = makeGetToken();

  const mapStateToProps = (state) => {
    return {
      lang: state.client?.setting?.lang || 'vi',
      theme: state.client?.setting?.theme === 'light' ? 'light' : 'dark',
      token: getToken(state),
    };
  };
  return mapStateToProps;
};

export default connect(makeMapStateToProps)(React.memo(TradingViewModal));
